import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ChangeDetectionStrategy, ViewEncapsulation, OnChanges } from '@angular/core';
import { PaginationService } from 'ngx-pagination';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.sass'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class PaginationComponent implements OnInit, OnDestroy, OnChanges {
    private _instance;
    private _sub;
    private _directionLinks = true;
    private _autoHide = true;

    public from = 0;
    public to = 0;
    public total = 0;
    public test = {};

    @Input() id: string;
    @Input() maxSize = 7;
    @Input() itemsPerPage = 10;

    @Input() previousLabel = '';
    @Input() nextLabel = '';
    @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();

    @Input()
    get directionLinks(): boolean {
        return this._directionLinks;
    }
    set directionLinks(value: boolean) {
        this._directionLinks = !!value && <any>value !== 'false';
    }

    @Input()
    get autoHide(): boolean {
        return this._autoHide;
    }
    set autoHide(value: boolean) {
        this._autoHide = !!value && <any>value !== 'false';
    }

    constructor(
      private service: PaginationService
    ) { }

    ngOnInit() {
      this._instance = this.service.getInstance(this.id || this.service.defaultId());

      this.updateValues();

      this._sub = this.service.change.subscribe(id => {
        this.updateValues();
      });
    }

    ngOnChanges() {
      this.updateValues();
    }

    ngOnDestroy() {
      this._sub.unsubscribe();
    }

    updateValues() {
      this._instance = this.service.getInstance(this.id);

      let from, to, total;

      this.test = this._instance;

      this.total = this._instance.totalItem;

      total = this._instance.totalItems;
      from  = (( this._instance.currentPage - 1) * this._instance.itemsPerPage) + 1;
      to    = this._instance.currentPage * this._instance.itemsPerPage;

      if (to > total) {
        to = total;
      }

      if (from > total) {
        from = total;
      }

      this.to = to;
      this.from = from;
      this.total = total;
    }
}
